var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1552 46.0213C50.0927 42.4482 56.0507 38.7301 63.1107 38.8954C70.1706 39.0608 76.7254 42.6384 75.7315 46.6163C74.8218 50.2428 69.1079 53.5419 62.048 53.3766C54.988 53.2112 50.2202 49.593 50.1571 46.0218L50.1552 46.0213Z",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2575 45.6715C57.2955 43.9823 59.7633 42.6699 62.7728 42.7405C65.778 42.812 68.5701 44.2894 68.1501 45.9269C67.763 47.4212 65.3323 48.7772 62.3228 48.7066C59.3132 48.6359 57.2176 47.3603 57.2556 45.671L57.2575 45.6715V45.6715Z",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6942 46.9724C57.6313 46.781 57.6019 46.5807 57.6056 46.3734L57.6075 46.3739C57.6427 44.8097 59.9249 43.5968 62.7085 43.6625C65.4896 43.7295 68.072 45.0952 67.6832 46.6096C67.6545 46.7169 67.6157 46.8234 67.5649 46.9285",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0398 47.2291C58.03 47.1479 58.0251 47.064 58.0265 46.9798L58.0285 46.9803C58.0617 45.5022 60.2197 44.3548 62.8516 44.4162C65.2532 44.4735 67.499 45.5569 67.5892 46.8352",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.482 48.7008L67.216 46.0017",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0302 47.3401L64.0679 44.497",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5374 55.6128C73.344 57.0719 68.5754 61.3271 59.708 60.171C50.8407 59.0149 50.7114 54.8532 50.7114 54.8532",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5511 52.8401L57.9411 53.6782L58.5157 53.7646C58.5157 53.7646 59.0641 53.2286 59.1177 53.1284",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9453 53.6758L58.2103 59.851",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5156 53.7656L58.8906 59.9393",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.597 52.6491C74.8896 49.8629 77.5328 48.7246 77.5328 48.7246C79.3431 47.7953 93.1676 42.1504 94.9184 41.1978C96.6693 40.2452 99.1777 37.9912 99.1384 35.9228C99.0632 32.0985 93.295 29.1075 86.2554 29.2389",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2031 46.5352C50.2031 46.5352 54.643 117.266 54.7764 118.481C54.9097 119.695 54.9149 123.266 62.5359 124.444C70.1568 125.623 74.9111 120.084 74.9111 120.084",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4981 41.4489C91.876 41.349 96.1894 38.9007 96.1325 35.9805C96.0756 33.0603 91.6699 30.774 86.2921 30.8739C80.9143 30.9737 76.6008 33.422 76.6577 36.3422C76.7146 39.2624 81.1203 41.5487 86.4981 41.4489Z",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6703 41.4459C91.7948 41.3508 95.905 39.0173 95.8508 36.234C95.7966 33.4508 91.5984 31.2716 86.474 31.3668C81.3495 31.4619 77.2393 33.7954 77.2935 36.5786C77.3477 39.3619 81.5459 41.5411 86.6703 41.4459Z",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1324 106.193C96.3992 102.178 100.174 37.3738 100.174 37.3738C100.174 37.3738 100.465 34.42 95.9287 31.4419C93.563 30.0269 90.1015 29.1685 86.2619 29.2395C85.6927 29.2496 85.1339 29.2812 84.5865 29.3306C82.9033 29.4277 81.1931 29.7483 79.521 30.383C73.4735 32.6765 62.2834 37.1414 61.1221 37.7245C59.9608 38.3076 59.613 38.6845 59.4761 39.1116L60.6074 39.0006C63.2247 37.174 68.2647 38.4665 71.119 39.4603C73.9739 40.4523 77.7084 43.537 76.8718 46.3322C76.5293 47.4761 75.8046 48.562 75.4208 49.4176C74.6103 51.2135 74.5437 53.233 74.5372 53.8109C74.5245 55.0659 74.9139 120.088 74.9139 120.088C74.9139 120.088 75.0897 121.017 76.0776 120.642C77.0655 120.268 91.0971 112.553 91.6678 112.213C92.2366 111.873 95.8675 110.209 96.1343 106.194L96.1324 106.193Z",
    stroke: "#004F9F",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 147,
    rx: 73.5,
    stroke: "#004F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.76af476728b33c814f7de5ae731281c7.svg";
export { ForwardRef as ReactComponent };